import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SsoSettingsResource } from '../resources/sso-settings.resource';
import { AuthService } from '../../app/_services/auth.service';
import { ErrorHandlerService } from '../custom/services/error-handler.service';
import { StoragePeriodTypeConstants } from '../constants/StoragePeriodTypeConstants';
import { Growl } from '../custom/services/growl.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'pkp-lng-admin-prisma-credit-limit-check-form',
    template: require('./lng-admin-prisma-credit-limit-check-form.component.html')
})
export class LngAdminPrismaCreditLimitCheckFormComponent implements OnInit {
    @Input('framework') newFramework: Partial<
        StorageFrameworkDto & StorageFrameworkCreationDto
    >;
    @Output() onFrameworkCreated = new EventEmitter<StorageFrameworkDto>();
    @Output() onCancel = new EventEmitter<void>();

    authUser: LoginResult;
    storagePeriodTypes: {
        value: StoragePeriodType;
        [label: string]: string;
    }[] = StoragePeriodTypeConstants.asLabelValueArray();
    submitting: boolean = false;

    constructor(
        private ssoSettingsResource: SsoSettingsResource,
        private authService: AuthService,
        private errorHandlerService: ErrorHandlerService,
        private growl: Growl
    ) {}

    ngOnInit(): void {
        this.authService.userLoginPromise.promise.then(
            (res) => (this.authUser = res)
        );

        if (this.newFramework == null) this.initNewCreditFramework();
        else this.newFramework = JSON.parse(JSON.stringify(this.newFramework));
    }

    initNewCreditFramework() {
        this.newFramework = { creditFactors: [], identifier: null };
    }

    removeCreditFactor(index: number) {
        this.newFramework.creditFactors.splice(index, 1);
    }

    initNewProductPeriod() {
        this.newFramework.creditFactors.push({
            value: {}
        } as StorageFrameworkCreditFactorDto);
    }

    submitNewFramework() {
        const allPeriodTypes = this.newFramework.creditFactors.map(
            (cF) => cF.periodType
        );
        const distinctPeriodTypes = allPeriodTypes.reduce((prev, curr) => {
            if (prev.indexOf(curr) === -1) prev.push(curr);
            return prev;
        }, []);

        if (allPeriodTypes.length > distinctPeriodTypes.length) {
            this.growl.show(
                'You must not specify multiple credit factors for the same period.',
                'danger'
            );
            return;
        }

        this.submitting = true;

        if ((this.newFramework as StorageFrameworkDto).id == null) {
            this.ssoSettingsResource
                .saveCreditFramework(
                    this.authUser.referenceId,
                    this.newFramework as StorageFrameworkCreationDto
                )
                .pipe(finalize(() => (this.submitting = false)))
                .subscribe((res) => {
                    this.growl.show(
                        'Successfully saved credit framework',
                        'success'
                    );
                    this.initNewCreditFramework();
                    this.onFrameworkCreated.emit(res);
                }, this.errorHandlerService.handle.bind(this));
        } else {
            this.ssoSettingsResource
                .updateCreditFramework(
                    this.authUser.referenceId,
                    this.newFramework as StorageFrameworkDto
                )
                .pipe(finalize(() => (this.submitting = false)))
                .subscribe((res) => {
                    this.growl.show(
                        'Successfully updated credit framework',
                        'success'
                    );
                    this.onFrameworkCreated.emit(res);
                }, this.errorHandlerService.handle.bind(this));
        }
    }
}
